module.exports = __webpack_public_path__ + "img/qg2_01.89bd7087.png";